import countries from './countries.json'

export const REGIONS = ['CANADA', 'US', 'EU', 'APAC', 'LAM + MX', 'MEA']

const CANADA = ['CA']
const US = ['US']

const EU = [
  'AD',
  'AL',
  'AT',
  'AX',
  'BA',
  'BE',
  'BG',
  'BY',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GB',
  'GG',
  'GI',
  'GR',
  'HR',
  'HU',
  'IE',
  'IM',
  'IS',
  'IT',
  'JE',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SJ',
  'SK',
  'SM',
  'UA',
  'VA',
  'XK', // XK (Kosovo) non-ISO but used by some backends
]

const MEA = [
  // Africa
  'DZ',
  'AO',
  'BJ',
  'BW',
  'BF',
  'BI',
  'CV',
  'CM',
  'CF',
  'TD',
  'KM',
  'CG',
  'CD',
  'CI',
  'DJ',
  'EG',
  'GQ',
  'ER',
  'ET',
  'GA',
  'GM',
  'GH',
  'GN',
  'GW',
  'KE',
  'LS',
  'LR',
  'LY',
  'MG',
  'MW',
  'ML',
  'MR',
  'MU',
  'MA',
  'MZ',
  'NA',
  'NE',
  'NG',
  'RE',
  'RW',
  'ST',
  'SN',
  'SC',
  'SL',
  'SO',
  'ZA',
  'SS',
  'SD',
  'SZ',
  'TZ',
  'TG',
  'TN',
  'UG',
  'EH',
  'YT',
  'ZM',
  'ZW',
  'SH',
  // Middle East
  'AE',
  'BH',
  'IL',
  'IQ',
  'IR',
  'JO',
  'KW',
  'LB',
  'OM',
  'PS',
  'QA',
  'SA',
  'SY',
  'TR',
  'YE',
]

const APAC = [
  // Asia (non-ME)
  'AF',
  'AM',
  'AZ',
  'BD',
  'BN',
  'BT',
  'CN',
  'GE',
  'HK',
  'ID',
  'IN',
  'JP',
  'KG',
  'KH',
  'KP',
  'KR',
  'KZ',
  'LA',
  'LK',
  'MM',
  'MN',
  'MO',
  'MY',
  'MV',
  'NP',
  'PH',
  'PK',
  'SG',
  'TH',
  'TJ',
  'TM',
  'TW',
  'UZ',
  'VN',
  // Oceania & Pacific territories
  'AS',
  'AU',
  'CK',
  'FJ',
  'FM',
  'GU',
  'KI',
  'MH',
  'MP',
  'NC',
  'NR',
  'NU',
  'NZ',
  'PF',
  'PG',
  'PN',
  'PW',
  'SB',
  'TK',
  'TO',
  'TV',
  'UM',
  'VU',
  'WF',
  'WS',
  // Indian Ocean/APAC territories
  'CX',
  'CC',
  'IO',
]

const LAM_MX = [
  'AG',
  'AI',
  'AR',
  'AW',
  'BB',
  'BL',
  'BQ',
  'BS',
  'BZ',
  'BO',
  'BR',
  'CL',
  'CO',
  'CR',
  'CU',
  'CW',
  'DM',
  'DO',
  'EC',
  'FK',
  'GD',
  'GF',
  'GP',
  'GT',
  'GY',
  'HN',
  'HT',
  'JM',
  'KN',
  'KY',
  'LC',
  'MF',
  'MQ',
  'MS',
  'MX',
  'NI',
  'PA',
  'PE',
  'PM',
  'PR',
  'PY',
  'SR',
  'SV',
  'TC',
  'TT',
  'UY',
  'VC',
  'VE',
  'VG',
  'VI',
  'BM',
  'SX',
]

export const REGION_BY_CODE = (() => {
  const map = {}
  for (const c of CANADA) map[c] = 'CANADA'
  for (const c of US) map[c] = 'US'
  for (const c of EU) map[c] = 'EU'
  for (const c of APAC) map[c] = 'APAC'
  for (const c of LAM_MX) map[c] = 'LAM + MX'
  for (const c of MEA) map[c] = 'MEA'
  return Object.freeze(map)
})()

export const getRegionByCode = (code) => REGION_BY_CODE[code?.toUpperCase?.()] || null

const NAME_TO_CODE_OVERRIDES = {
  'United States of America': 'US',
  'Russian Federation': 'RU',
  'Congo (Kinshasa)': 'CD',
  'Congo (Brazzaville)': 'CG',
  'Democratic Republic of the Congo': 'CD',
  'Republic of the Congo': 'CG',
  'Côte d’Ivoire': 'CI',
  "Cote d'Ivoire": 'CI',
  Czechia: 'CZ',
  'Czech Republic': 'CZ',
  'North Macedonia': 'MK',
  Eswatini: 'SZ',
  Swaziland: 'SZ',
  Myanmar: 'MM',
  Burma: 'MM',
  'Timor-Leste': 'TL',
  'East Timor': 'TL',
  'State of Palestine': 'PS',
  Palestine: 'PS',
  Micronesia: 'FM',
  'Federated States of Micronesia': 'FM',
  'Cape Verde': 'CV',
  'Lao PDR': 'LA',
  Laos: 'LA',
  'Sao Tome and Principe': 'ST',
  'Ivory Coast': 'CI',
  Tanzania: 'TZ',
  Moldova: 'MD',
  Venezuela: 'VE',
  Bolivia: 'BO',
  Syria: 'SY',
  Iran: 'IR',
  'North Korea': 'KP',
  'South Korea': 'KR',
  'United Kingdom': 'GB',
  Kosovo: 'XK',
}

const normalize = (s) =>
  s
    ?.toLowerCase()
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.replace(/&/g, 'and')
    ?.replace(/[^a-z0-9 ]/g, ' ')
    ?.replace(/\s+/g, ' ')
    ?.trim()

const NAME_TO_CODE_FROM_LIST = (() => {
  const map = {}
  for (const c of countries) if (c?.name && c?.code) map[c.name] = c.code
  return map
})()

const NAME_TO_CODE_NORMALIZED = (() => {
  const map = {}
  for (const c of countries) if (c?.name && c?.code) map[normalize(c.name)] = c.code
  return map
})()

export const inferCodeFromGeoName = (geoName) => {
  if (NAME_TO_CODE_OVERRIDES[geoName]) return NAME_TO_CODE_OVERRIDES[geoName]
  if (NAME_TO_CODE_FROM_LIST[geoName]) return NAME_TO_CODE_FROM_LIST[geoName]
  const norm = normalize(geoName)
  if (NAME_TO_CODE_NORMALIZED[norm]) return NAME_TO_CODE_NORMALIZED[norm]
  return null
}

export const getRegionByGeoName = (geoName) => getRegionByCode(inferCodeFromGeoName(geoName))

export const buildCountriesByRegionForMap = (geoFeatures) => {
  const out = Object.fromEntries(REGIONS.map((r) => [r, []]))
  for (const f of geoFeatures) {
    const n = f?.properties?.name
    const region = getRegionByGeoName(n)
    if (region) out[region].push(n)
  }
  return out
}

export const isUnknownCountryCode = (code) => code == null || code === '' || code === 'ZZ'

export const getCountryName = (code) => countries.find((c) => c.code === code)?.name || code

export const getCountryDisplay = (code, unknownLabel = 'Unknown') => (isUnknownCountryCode(code) ? unknownLabel : getCountryName(code))

export const getRegionDisplay = (region, unknownLabel = 'Unknown') => (region == null || region === '' ? unknownLabel : region)

export const availableCodesFromData = (rows = []) => {
  const s = new Set()
  for (const r of rows) {
    const code = (r?.countryCode || r?.country || '')?.toUpperCase?.()
    if (code && !isUnknownCountryCode(code) && Number(r?.count || 0) > 0) s.add(code)
  }
  return s
}

export const sumCountsByRegionFromData = (rows = []) => {
  const regionCounts = Object.fromEntries(REGIONS.map((r) => [r, 0]))
  let unknownTotal = 0
  for (const r of rows) {
    const n = Number(r?.count || 0)
    const code = (r?.countryCode || r?.country || '')?.toUpperCase?.()
    const region = code && !isUnknownCountryCode(code) ? getRegionByCode(code) : null
    if (region) regionCounts[region] += n
    else unknownTotal += n
  }
  return { regionCounts, unknownTotal }
}
